import { z } from "zod";

const baseSchema = z.object({
    parameter: z.string().min(1, "forms.general-validation.key_required"),
    value: z.string().min(1, "forms.general-validation.value_required"),
    description: z.string().optional(),
});

export const schema = baseSchema;

/** existingKeys must exclude the key of the field currently being edited. */
export const createSchema = (existingKeys: string[]) =>
    baseSchema.refine((data) => !existingKeys.includes(data.parameter), {
        message: "forms.general-validation.key_already_exists",
        path: ["parameter"],
    });

export type AddApiToolCustomFieldData = z.infer<typeof baseSchema>;
